import {
  contractorSchema,
  publicPaginationSchema,
  publicSortSchema,
  schemes,
  zSchema,
} from "@zeal/common";

export const getContractorsRequestSchema = zSchema.object({
  isOnboarded: zSchema.boolean().optional(),
  q: zSchema.string().optional(),
  customerAccountID: zSchema.string().optional(),
  ...publicPaginationSchema.shape,
  ...publicSortSchema.shape,
});

export type TGetContractorsRequestSchema = zSchema.infer<
  typeof getContractorsRequestSchema
>;

export const getContractorsResponseSchema = zSchema.array(
  contractorSchema.extend({
    bankAccountID: schemes.mongoOrUuid().optional(),
  })
);

export type TGetContractorsResponseSchema = zSchema.infer<
  typeof getContractorsResponseSchema
>;
